(function () {
  // Bind variant:change only once per page (prevents duplicate refresh calls)
  function bindVariantChangeOnce(handler) {
    if (window.__AFFIRM_ALA_VARIANT_BOUND__) return;
    window.__AFFIRM_ALA_VARIANT_BOUND__ = true;
    document.addEventListener('variant:change', handler);
  }

  function initAlaFor(root) {
    if (!root) return;

    // Guard: do not bind twice if this widget re-renders
    if (root.dataset.affirmAlaInit === '1') return;
    root.dataset.affirmAlaInit = '1';

    var ala = root.querySelector('.affirm-as-low-as');
    var handle = root.getAttribute('data-handle');
    if (!ala || !handle) return;

    function setAmountCents(cents) {
      if (typeof cents !== 'number') return;
      ala.setAttribute('data-amount', String(cents));
      if (window.affirm && affirm.ui && typeof affirm.ui.refresh === 'function') {
        affirm.ui.refresh();
      }
    }

    function findNearestAddToCartForm() {
      // Most reliable anchor on Dawn PDP: product-info
      var pi = root.closest('product-info');
      if (pi) {
        var f1 = pi.querySelector('form[action="/cart/add"]');
        if (f1) return f1;
      }

      // Next best: closest section (in case markup differs)
      var section = root.closest('section');
      if (section) {
        var f2 = section.querySelector('form[action="/cart/add"]');
        if (f2) return f2;
      }

      // Fallbacks (should rarely be needed)
      return (
        document.querySelector('section[id^="ProductInfo-"] form[action="/cart/add"]') ||
        document.querySelector('form[action="/cart/add"]')
      );
    }

    var form = findNearestAddToCartForm();
    var idInput = form && form.querySelector('[name="id"]');

    // Always listen for Dawn's variant event (even if fetch fails)
    bindVariantChangeOnce(function (e) {
      var v = e.detail && e.detail.variant;
      if (v && typeof v.price === 'number') setAmountCents(v.price);
    });

    // Fetch product JSON to map variant id -> price (cents)
    fetch(
      (window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/') +
        'products/' +
        handle +
        '.js',
      { credentials: 'same-origin' }
    )
      .then(function (r) {
        return r.json();
      })
      .then(function (prod) {
        function refreshFromVariantId() {
          if (!idInput) return;
          var vid = parseInt(idInput.value, 10);
          if (!vid || !prod || !Array.isArray(prod.variants)) return;

          var v = prod.variants.find(function (x) {
            return x.id === vid;
          });
          if (v && typeof v.price === 'number') setAmountCents(v.price);
        }

        // Initial render
        refreshFromVariantId();

        // Fallback: hidden id input changes & generic form changes
        if (idInput) idInput.addEventListener('change', refreshFromVariantId);
        if (form) form.addEventListener('change', refreshFromVariantId);
      })
      .catch(function () {
        // No console noise. variant:change will still keep pricing updated on Dawn.
      });
  }

  function boot() {
    document.querySelectorAll('[data-affirm-ala]').forEach(initAlaFor);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
